// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SelectField Component Styles */

.scl--web-component-select-field-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  padding-bottom: 20px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  position: relative;
}

.scl--web-component-select-field-input-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  height: 52px;
  border: 1px solid #7D8187;
  border-radius: 2px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  position: relative;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.scl--web-component-select-field-input-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  background: var(--scl-input-field-select, #84A578);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scl--web-component-select-field-input-plate.open::after {
  opacity: 1;
}

.scl--web-component-select-field-input-plate:hover:not(.open) {
  border-color: #9EA0A4;
}

.scl--web-component-select-field-input-plate.open {
  border-color: #9EA0A4;
}

.scl--web-component-select-field-input-plate.warning::after {
  background: #FFC18E;
  opacity: 1;
}

.scl--web-component-select-field-input-plate.error::after {
  background: #F8868A;
  opacity: 1;
}

.scl--web-component-select-field-input-plate.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.scl--web-component-select-field-input-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 20px;
  gap: 12px;
  width: 100%;
  height: 52px;
  flex: 1;
  order: 0;
  flex-grow: 1;
  box-sizing: border-box;
}

.scl--web-component-select-field-value-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  height: 100%;
  flex: 1;
  order: 1;
  flex-grow: 1;
}

.scl--web-component-select-field-text-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px;
  width: 100%;
  height: 100%;
  flex: 1;
  order: 0;
  flex-grow: 1;
  position: relative;
}

.scl--web-component-select-field-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: var(--primary-font);
  font-style: light;
  font-weight: 274;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.50px;
  color: #FFFFFF;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scl--web-component-select-field-chevron-icon {
  width: 16px;
  height: 16px;
  flex: none;
  order: 1;
  flex-grow: 0;
  flex-shrink: 0;
  transition: transform 0.3s ease, stroke 0.3s ease;
}

.scl--web-component-select-field-chevron-icon path {
  stroke: #7D8187;
  transition: stroke 0.3s ease;
}

.scl--web-component-select-field-input-plate:hover .scl--web-component-select-field-chevron-icon path,
.scl--web-component-select-field-input-plate.open .scl--web-component-select-field-chevron-icon path {
  stroke: #FFFFFF;
}

.scl--web-component-select-field-input-plate.open .scl--web-component-select-field-chevron-icon {
  transform: rotate(180deg);
}

/* ✅ Floating Label Styles - Always visible, animates position */
.scl--web-component-select-field-label {
  position: absolute;
  left: 21px;
  top: 50%;
  transform: translateY(-50%);
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #7D8187;
  background: transparent;
  padding: 0 4px;
  margin: 0 -4px;
  pointer-events: none;
  transition: all 0.3s ease;
  z-index: 1;
  opacity: 1;
}

/* ✅ Floating state - label moves to top */
.scl--web-component-select-field-label.floating {
  top: 0;
  transform: translateY(-50%);
  font-size: 14px;
  line-height: 16px;
  background: #0A0A0A;
  color: #7D8187;
  padding: 0 6px;
  margin: 0 -6px;
}

/* ✅ Hover effect on label */
.scl--web-component-select-field-input-plate:hover:not(.open) .scl--web-component-select-field-label {
  color: #C9CACD;
}

.scl--web-component-select-field-input-plate:hover:not(.open) .scl--web-component-select-field-label .scl--web-component-select-field-required-asterisk {
  color: #EB5252;
}

/* Required Asterisk Styles */
.scl--web-component-select-field-required-asterisk {
  color: #EB5252;
}

/* Dropdown Styles */
.scl--web-component-select-field-dropdown {
  position: absolute;
  top: calc(100% + -8px);
  left: 0;
  right: 0;
  background: #000000;
  border-radius: 2px;
  max-height: 0;
  overflow: hidden;
  z-index: 1000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  opacity: 0;
  transform: translateY(-10px);
  transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease, visibility 0s ease 0.3s;
  pointer-events: none;
  visibility: hidden;
}

.scl--web-component-select-field-dropdown.open {
  max-height: 280px;
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
  visibility: visible;
  transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease, visibility 0s ease 0s;
}

.scl--web-component-select-field-search {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 17px;
  gap: 14px;
  width: 100%;
  height: 37px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.scl--web-component-select-field-search-icon {
  width: 20px;
  height: 17px;
  flex: none;
  flex-grow: 0;
}

.scl--web-component-select-field-search-icon path,
.scl--web-component-select-field-search-icon ellipse {
  stroke: #7D8187;
}

.scl--web-component-select-field-search-input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 14px;
  line-height: 21px;
  color: #FFFFFF;
  padding: 0;
  flex: 1;
  flex-grow: 1;
}

.scl--web-component-select-field-search-input::placeholder {
  color: #7D8187;
}

.scl--web-component-select-field-options {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px 0;
  gap: 0px;
  max-height: 230px;
  overflow-y: auto;
}

.scl--web-component-select-field-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 20px;
  gap: 10px;
  width: 100%;
  height: 38px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
}

.scl--web-component-select-field-option:hover {
  background-color: rgba(125, 129, 135, 0.1);
}

.scl--web-component-select-field-option.selected {
  background-color: rgba(125, 129, 135, 0.2);
}

.scl--web-component-select-field-option-icon {
  display: none;
  width: 16px;
  height: 16px;
  flex: none;
  flex-grow: 0;
}

.scl--web-component-select-field-option-icon img {
  width: 16px;
  height: auto;
  object-fit: contain;
}

.scl--web-component-select-field-option-label {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #7D8187;
  flex: 1;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scl--web-component-select-field-no-options {
  padding: 12px 10px;
  font-family: var(--primary-font);
  font-size: 14px;
  color: #7D8187;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

/* Selected Icon in Input */
.scl--web-component-select-field-selected-icon {
  width: 20px;
  height: 16px;
  flex: none;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.scl--web-component-select-field-selected-icon img {
  width: 20px;
  height: auto;
  object-fit: contain;
}

.scl--web-component-select-field-assistive {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 4px 2px 14px;
  height: 16px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: rgba(255, 255, 255, 0.54);
}

.scl--web-component-select-field-assistive.error {
  color: #FF5252;
}

/* Custom scrollbar for dropdown */
.scl--web-component-select-field-options::-webkit-scrollbar {
  width: 4px;
}

.scl--web-component-select-field-options::-webkit-scrollbar-track {
  background: #393939;
}

.scl--web-component-select-field-options::-webkit-scrollbar-thumb {
  background: #1C1C1C;
  border-radius: 0px;
}

.scl--web-component-select-field-options::-webkit-scrollbar-thumb:hover {
  background: #7D8187;
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/dropdown/select-field/css/selectField.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kDAAkD;EAClD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,MAAM;EACN,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,UAAU;EACV,4BAA4B;EAC5B,iGAAiG;EACjG,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,+FAA+F;AACjG;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* SelectField Component Styles */\n\n.scl--web-component-select-field-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  padding-bottom: 20px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  position: relative;\n}\n\n.scl--web-component-select-field-input-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  height: 52px;\n  border: 1px solid #7D8187;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n  position: relative;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--web-component-select-field-input-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  background: var(--scl-input-field-select, #84A578);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.scl--web-component-select-field-input-plate.open::after {\n  opacity: 1;\n}\n\n.scl--web-component-select-field-input-plate:hover:not(.open) {\n  border-color: #9EA0A4;\n}\n\n.scl--web-component-select-field-input-plate.open {\n  border-color: #9EA0A4;\n}\n\n.scl--web-component-select-field-input-plate.warning::after {\n  background: #FFC18E;\n  opacity: 1;\n}\n\n.scl--web-component-select-field-input-plate.error::after {\n  background: #F8868A;\n  opacity: 1;\n}\n\n.scl--web-component-select-field-input-plate.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.scl--web-component-select-field-input-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px 20px;\n  gap: 12px;\n  width: 100%;\n  height: 52px;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  box-sizing: border-box;\n}\n\n.scl--web-component-select-field-value-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0;\n  height: 100%;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n}\n\n.scl--web-component-select-field-text-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  position: relative;\n}\n\n.scl--web-component-select-field-text {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-family: var(--primary-font);\n  font-style: light;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 20px;\n  letter-spacing: 0.50px;\n  color: #FFFFFF;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.scl--web-component-select-field-chevron-icon {\n  width: 16px;\n  height: 16px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  flex-shrink: 0;\n  transition: transform 0.3s ease, stroke 0.3s ease;\n}\n\n.scl--web-component-select-field-chevron-icon path {\n  stroke: #7D8187;\n  transition: stroke 0.3s ease;\n}\n\n.scl--web-component-select-field-input-plate:hover .scl--web-component-select-field-chevron-icon path,\n.scl--web-component-select-field-input-plate.open .scl--web-component-select-field-chevron-icon path {\n  stroke: #FFFFFF;\n}\n\n.scl--web-component-select-field-input-plate.open .scl--web-component-select-field-chevron-icon {\n  transform: rotate(180deg);\n}\n\n/* ✅ Floating Label Styles - Always visible, animates position */\n.scl--web-component-select-field-label {\n  position: absolute;\n  left: 21px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: #7D8187;\n  background: transparent;\n  padding: 0 4px;\n  margin: 0 -4px;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  z-index: 1;\n  opacity: 1;\n}\n\n/* ✅ Floating state - label moves to top */\n.scl--web-component-select-field-label.floating {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 14px;\n  line-height: 16px;\n  background: #0A0A0A;\n  color: #7D8187;\n  padding: 0 6px;\n  margin: 0 -6px;\n}\n\n/* ✅ Hover effect on label */\n.scl--web-component-select-field-input-plate:hover:not(.open) .scl--web-component-select-field-label {\n  color: #C9CACD;\n}\n\n.scl--web-component-select-field-input-plate:hover:not(.open) .scl--web-component-select-field-label .scl--web-component-select-field-required-asterisk {\n  color: #EB5252;\n}\n\n/* Required Asterisk Styles */\n.scl--web-component-select-field-required-asterisk {\n  color: #EB5252;\n}\n\n/* Dropdown Styles */\n.scl--web-component-select-field-dropdown {\n  position: absolute;\n  top: calc(100% + -8px);\n  left: 0;\n  right: 0;\n  background: #000000;\n  border-radius: 2px;\n  max-height: 0;\n  overflow: hidden;\n  z-index: 1000;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease, visibility 0s ease 0.3s;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.scl--web-component-select-field-dropdown.open {\n  max-height: 280px;\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n  visibility: visible;\n  transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease, visibility 0s ease 0s;\n}\n\n.scl--web-component-select-field-search {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 17px;\n  gap: 14px;\n  width: 100%;\n  height: 37px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.scl--web-component-select-field-search-icon {\n  width: 20px;\n  height: 17px;\n  flex: none;\n  flex-grow: 0;\n}\n\n.scl--web-component-select-field-search-icon path,\n.scl--web-component-select-field-search-icon ellipse {\n  stroke: #7D8187;\n}\n\n.scl--web-component-select-field-search-input {\n  width: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 14px;\n  line-height: 21px;\n  color: #FFFFFF;\n  padding: 0;\n  flex: 1;\n  flex-grow: 1;\n}\n\n.scl--web-component-select-field-search-input::placeholder {\n  color: #7D8187;\n}\n\n.scl--web-component-select-field-options {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 8px 0;\n  gap: 0px;\n  max-height: 230px;\n  overflow-y: auto;\n}\n\n.scl--web-component-select-field-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 20px;\n  gap: 10px;\n  width: 100%;\n  height: 38px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.scl--web-component-select-field-option:hover {\n  background-color: rgba(125, 129, 135, 0.1);\n}\n\n.scl--web-component-select-field-option.selected {\n  background-color: rgba(125, 129, 135, 0.2);\n}\n\n.scl--web-component-select-field-option-icon {\n  display: none;\n  width: 16px;\n  height: 16px;\n  flex: none;\n  flex-grow: 0;\n}\n\n.scl--web-component-select-field-option-icon img {\n  width: 16px;\n  height: auto;\n  object-fit: contain;\n}\n\n.scl--web-component-select-field-option-label {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 18px;\n  color: #7D8187;\n  flex: 1;\n  flex-grow: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.scl--web-component-select-field-no-options {\n  padding: 12px 10px;\n  font-family: var(--primary-font);\n  font-size: 14px;\n  color: #7D8187;\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Selected Icon in Input */\n.scl--web-component-select-field-selected-icon {\n  width: 20px;\n  height: 16px;\n  flex: none;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n}\n\n.scl--web-component-select-field-selected-icon img {\n  width: 20px;\n  height: auto;\n  object-fit: contain;\n}\n\n.scl--web-component-select-field-assistive {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px 4px 2px 14px;\n  height: 16px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: rgba(255, 255, 255, 0.54);\n}\n\n.scl--web-component-select-field-assistive.error {\n  color: #FF5252;\n}\n\n/* Custom scrollbar for dropdown */\n.scl--web-component-select-field-options::-webkit-scrollbar {\n  width: 4px;\n}\n\n.scl--web-component-select-field-options::-webkit-scrollbar-track {\n  background: #393939;\n}\n\n.scl--web-component-select-field-options::-webkit-scrollbar-thumb {\n  background: #1C1C1C;\n  border-radius: 0px;\n}\n\n.scl--web-component-select-field-options::-webkit-scrollbar-thumb:hover {\n  background: #7D8187;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
